import React from "react";
import ReactPaginate from "react-paginate";

export default function Pagination({ pageCount, pageValue, setPage }) {
  return (
    <>
      {pageCount > 1 && (
        <div className="w-full flex justify-center py-3">
          <ReactPaginate
            pageCount={pageCount}
            forcePage={pageValue ? pageValue - 1 : 0}
            previousLabel={"<"}
            nextLabel={">"}
            breakLabel={"..."}
            marginPagesDisplayed={2}
            onPageChange={(selected) => setPage(selected.selected)}
            
            // container
            containerClassName="flex gap-2 items-center select-none"

            // page buttons
            pageClassName="rounded-md border border-gray-300"
            pageLinkClassName="px-3 py-1 block text-gray-700 hover:bg-gray-200 rounded-md text-sm"

            // previous & next
            previousClassName="rounded-md border border-gray-300"
            previousLinkClassName="px-3 py-1 block text-gray-700 hover:bg-gray-200 rounded-md text-sm"
            nextClassName="rounded-md border border-gray-300"
            nextLinkClassName="px-3 py-1 block text-gray-700 hover:bg-gray-200 rounded-md text-sm"

            // break
            breakClassName="rounded-md border border-gray-300"
            breakLinkClassName="px-3 py-1 block text-gray-700"

            // active
            activeClassName="bg-[#012547] text-white border-[#012547]"
          />
        </div>
      )}
    </>
  );
}